import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';

import NukaCarousel from '../../src/nukaCarousel/NukaCarousel.jsx';

// Get Photo Carousels container and create NukaCarousel
let domPhotosContainer = document.querySelector('.photo-carousel');
if (domPhotosContainer) {
  ReactDOM.render(<NukaCarousel media={preloaded.recent_pictures} team_title={preloaded.team_title} type='photos' />, domPhotosContainer);
}